export const GoogleMapApiConfig = 'AIzaSyABmcUezNmqnunkSWFWwaOVHtSDB1EAfIc';